import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-terminos',
  templateUrl: './terminos.component.html',
  styleUrls: ['./terminos.component.scss']
})
export class TerminosComponent implements OnInit {
  @ViewChild('sectionSubscribe', { static: true }) sectionSubscribeDiv: ElementRef;
  constructor() { }

  ngOnInit(): void {
    this.scrollToSubscribe();
  }

  scrollToSubscribe(){
    this.sectionSubscribeDiv.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

}
